export const types = {
	INIT_DOCUMENTS: "INIT_FORM_CLU_DOCUMENTS",
	ADD_DOCUMENT: "ADD_FORM_CLU_DOCUMENT",
	REMOVE_DOCUMENT: "REMOVE_FORM_CLU_DOCUMENT",
	RESET_DOCUMENTS: "RESET_FORM_CLU_DOCUMENTS",
}

export const initFormCLUDocs = (documents) => {
	return (dispatch) => dispatch({
		type: types.INIT_DOCUMENTS,
		payload: documents
	})
}

export const addFormCLUDoc = (docData) => {
	return (dispatch) => dispatch({
		type: types.ADD_DOCUMENT,
		payload: docData
	})
}

export const removeFormCLUDoc = (docId) => {
	return (dispatch) => dispatch({
		type: types.REMOVE_DOCUMENT,
		payload: docId
	})
}

export const resetFormCLUDocs = () => {
	return (dispatch) => dispatch({
		type: types.RESET_DOCUMENTS,
	})
}
